export var ModoCRUDEnum;
(function (ModoCRUDEnum) {
    ModoCRUDEnum["CREATE"] = "CREATE";
    ModoCRUDEnum["UPDATE"] = "UPDATE";
    ModoCRUDEnum["DELETE"] = "DELETE";
    ModoCRUDEnum["VIEW"] = "VIEW";
})(ModoCRUDEnum || (ModoCRUDEnum = {}));
(function (ModoCRUDEnum) {
    var mapDescricao = new Map([
        [ModoCRUDEnum.CREATE, 'Incluir'],
        [ModoCRUDEnum.UPDATE, 'Alterar'],
        [ModoCRUDEnum.DELETE, 'Excluir '],
        [ModoCRUDEnum.VIEW, 'Visualizar'],
    ]);
    function getDescricao(key) {
        return mapDescricao.get(key);
    }
    ModoCRUDEnum.getDescricao = getDescricao;
})(ModoCRUDEnum || (ModoCRUDEnum = {}));
